import {BaseGlobalDataLayerFieldsType} from 'constants/flow/flowTypesGlobalDataLayer';
import {CustomerType} from 'constants/flow/flowTypesCheckout';

import {getUrlParameter} from 'libs/url';
import {getGaClientIdOutsideCall} from 'libs/analytics/refactoringAnalytics';

import {emptyStringIsFalsy} from './helpers';

/**
 * Get base fields for GlobalDataLayer from customer
 * @param {CustomerType} customer - Application store
 * @returns {BaseGlobalDataLayerFieldsType} Base fields from customer
 */
export const getFieldsForGlobalDataLayer = (
    customer: CustomerType,
): BaseGlobalDataLayerFieldsType => {
    return {
        email: emptyStringIsFalsy(customer.email),
        md5: emptyStringIsFalsy(customer.md5),
        sha1: emptyStringIsFalsy(customer.sha1),
        sha256: emptyStringIsFalsy(customer.sha256),
        subscriber_id: emptyStringIsFalsy(customer.sid),
        first_name: emptyStringIsFalsy(customer.firstname),
        last_name: emptyStringIsFalsy(customer.lastname),
        subscription_date: emptyStringIsFalsy(customer.subscription_date),
        simple_subscription_date: emptyStringIsFalsy(customer.simple_subscription_date),
        login_in_status: customer.login_in_status,
        login_method: customer.login_method,
        page_name: document.title,
        page_url: window.location.href,
        currency: customer.currency ? emptyStringIsFalsy(customer.currency.code) : '',
        keywords_searched: getUrlParameter('q'),
        client_id_ga: getGaClientIdOutsideCall(),
        node_name: window.d15,
    };
};
